import { createAction, props } from '@ngrx/store';

export const setIncludeBenchmarkDefault = createAction(
    '[Custom PDF Report Builder] Set Include Benchmark Default',
    props<{ include_benchmark_default: boolean }>()
);
